// extracted by mini-css-extract-plugin
export default {"root":"SectionBikiniAthlets_root__BRo2E","wrapper":"SectionBikiniAthlets_wrapper__Eieae","title":"SectionBikiniAthlets_title__J4zCo","info":"SectionBikiniAthlets_info__CSxOv"};